export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9484.4277ad14.jpg";